import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateMaintenanceEvent($companyId: ID!, $id: ID!, $attributes: MaintenanceEventAttributes!) {
    updateMaintenanceEvent(companyId: $companyId, id: $id, attributes: $attributes) {
      maintenanceEvent {
        id
        ...UpdatedMaintenanceEvent
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedMaintenanceEvent on MaintenanceEvent {
    id
    details
    result
    maintenanceTasks {
      nodes {
        id
        result
        maintenanceTypeTask { id }
      }
    }
  }
`
